import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Fade out the branded splash screen once the app has mounted.
function hideSplash() {
  const s = document.getElementById("kmt-splash");
  if (!s) return;
  s.classList.add("kmt-hide");
  setTimeout(() => s.remove(), 500);
}
requestAnimationFrame(() => setTimeout(hideSplash, 300));
